<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'components.components-parent-label' | translate }}"
      pageTitle="{{ 'components.components-title-label' | translate }}">
    </app-page-header>
  </div>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>
        <!-- Sessão de filtro de Componentes -->
        <div class="form-fields-box" [ngClass]="!filterComponents ? 'closed' : ''" [formGroup]="filterComponentForm">
          <h2 (click)="filterComponentsOpen()">
            {{ "components.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filterComponents ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "components.form-filter-keyword" | translate }}
              </mat-label>
              <input matInput #search formControlName="keyword" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "components.form-filter-select-component" | translate }}
              </mat-label>
              <mat-select #materialTypes formControlName="componentType">
                @for (item of componentsTypeList; track item) {
                  <mat-option appearance="outline" [value]="item.id">
                    {{ item.reference }}
                  </mat-option>
                }
                @if (getcomponentsType) {
                  <mat-option><mat-spinner [diameter]="30"></mat-spinner></mat-option>
                }
                @if (componentsTypeList.length === 0) {
                  <mat-option>
                    {{ "components.no-components-registred" | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (!filterComponentLoading) {
            <button class="btn btn-success" title="Filtrar"
              (click)="filterComponent(search.value, materialTypes.value)">
              {{ "components.form-button-filter" | translate }}
            </button>
          }
          @if (filterComponentLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <!-- Sessão criar Componentes -->
        <div class="form-fields-box" [ngClass]="!createComponents ? 'closed' : ''" [formGroup]="createComponentForm">
          <h2 (click)="createComponentsOpen()">
            {{ "components.form-register-label" | translate }}
          </h2>
          <hr [ngClass]="!createComponents ? 'hr-open' : ''" />
          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "components.form-register-serial-number" | translate }}
              </mat-label>
              <input matInput formControlName="serialNumber" maxLength="13" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{
                "components.form-search-by-component-type" | translate
              }}</mat-label>
              <mat-select formControlName="componentType" #componentId
                (valueChange)="componentsTypeGetId(componentId.value)">
                @for (item of componentsTypeList; track item) {
                  <mat-option [value]="item.id">
                    {{ item.reference }}
                  </mat-option>
                }

                @if (componentTypeLoading$ | async) {
                  <mat-option>
                    <mat-spinner [diameter]="30"> </mat-spinner>
                  </mat-option>
                }

                @if (componentsTypeList.length === 0) {
                  <mat-option>
                    {{ "components.no-components-registred" | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">3</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "components.form-search-by-installation" | translate }}
              </mat-label>
              <mat-select formControlName="installations" #installationId=matSelect
                (valueChange)="installationTypeGetId(installationId.value)">
                @for (item of installationTypeList; track item) {
                  <mat-option [value]="item.id">
                    {{ item.reference }}
                  </mat-option>
                }

                @if (componentInstallationLoading$ | async) {
                  <mat-option>
                    <mat-spinner [diameter]="30"> </mat-spinner>
                  </mat-option>
                }

                @if (installationTypeList.length === 0) {
                  <mat-option>
                    {{ "components.no-installations-registred" | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (!(componentTypeLoading$ | async)) {
            <button title="Salvar" class="btn btn-success"
              (click)="createComponent()">
              {{ "components.form-button-save" | translate }}
            </button>
          }
          @if (componentTypeLoading$ | async) {
            <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (ELEMENT_DATA.length) {
      <div class="col-lg-7 col-xl-8 col-sm-12">
        <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
          [hasPDF]="true" [hasCSV]="true" (downloadCSV)="downloadCSV()" (downloadPDF)="downloadPDF()">
        </app-table-header>
        <!-- Sessão tabela -->
        <div class="table-div mt-2 mt-lg-3 mt-xl-3">
          <p-table [value]="ELEMENT_DATA" [rows]="10" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="serialNumber"> {{ "components.column-serial-number" | translate }}
                </th>
                <th pSortableColumn="componentType"> {{ "components.column-component-type" | translate }}
                </th>
                <th pSortableColumn="installations"> {{ "components.column-installations" | translate }}
                </th>
                <th pSortableColumn="actions"> {{ "components.column-actions" | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
              <tr>
                <td>{{row.serialNumber}}</td>
                <td>{{row.componentType.reference}}</td>
                <td>{{row.installation.reference}}</td>
                <td on-mouseover="row.view = true" on-mouseleave="row.view = false">
                  <button [ngClass]="row.view === true ? 'hover' : ' '" class="btn btn-success mb-2 view"
                    (click)="openSidebar(row)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-pencil-square">
                      <path
                        d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        }
      </div>

      <!-- Editar informações sidebar -->
      @if (openEdit) {
        <div class="sidebar-edit" [formGroup]="updateComponentForm">
          <mat-icon (click)="closeSidebar()">clear</mat-icon>
          <h2>Editar Componente</h2>
          <hr />
          <mat-form-field appearance="outline">
            <mat-label>{{
              "components.form-register-serial-number" | translate
            }}</mat-label>
            <input matInput formControlName="serialNumber" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "components.column-component-type" | translate }}
            </mat-label>
            <mat-select formControlName="componentType" #componentId>
              @for (item of componentsTypeList; track item) {
                <mat-option [value]="item.id">
                  {{ item.reference }}
                </mat-option>
              }
              @if (componentTypeLoading$ | async) {
                <mat-option>
                  <mat-spinner [diameter]="30"> </mat-spinner>
                </mat-option>
              }
              @if (componentsTypeList.length === 0) {
                <mat-option>
                  {{ "components.no-components-registred" | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ "components.form-search-by-installation" | translate }}
            </mat-label>
            <mat-select #installationId formControlName="installations">
              @for (item of installationTypeList; track item) {
                <mat-option [value]="item.id">
                  {{ item.reference }}
                </mat-option>
              }
              @if (componentInstallationLoading$ | async) {
                <mat-option>
                  <mat-spinner [diameter]="30"> </mat-spinner>
                </mat-option>
              }
              @if (installationTypeList.length === 0) {
                <mat-option>
                  {{ "components.no-installations-registred" | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!updateComponentLoading) {
            <button class="btn btn-success" (click)="updateComponent()">
              {{ "components.btn-send" | translate }}
            </button>
          }
          @if (updateComponentLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      }
    </div>